var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-field-layout",
    {
      attrs: {
        validator: _vm.validator,
        "has-focus": _vm.hasFocus,
        "side-grid": _vm.sideGrid,
        "no-underline": "",
      },
      scopedSlots: _vm._u(
        [
          {
            key: "label",
            fn: function () {
              return [
                _vm._t("label", function () {
                  return [
                    _c("base-label", {
                      attrs: { "input-id": _vm.id, label: _vm.label },
                    }),
                  ]
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "prepend-input",
            fn: function () {
              return [_vm._t("prepend-input")]
            },
            proxy: true,
          },
          {
            key: "append-input",
            fn: function () {
              return [_vm._t("append-input")]
            },
            proxy: true,
          },
          {
            key: "before-input",
            fn: function () {
              return [_vm._t("before-input")]
            },
            proxy: true,
          },
          {
            key: "after-input",
            fn: function () {
              return [_vm._t("after-input")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-column" },
        [
          _c(
            "base-radio",
            _vm._b(
              {
                staticClass: "p-default p-curve multi-line",
                attrs: { value: _vm.valueModel, "input-type": "checkbox" },
                on: {
                  "update:value": function ($event) {
                    _vm.valueModel = $event
                  },
                  focus: _vm.handleBaseFocus,
                  blur: _vm.handleBaseBlur,
                  change: _vm.handleBaseChange,
                  input: _vm.handleBaseInput,
                },
              },
              "base-radio",
              _vm.$props,
              false
            ),
            [_vm._v("\n      " + _vm._s(_vm.optionLabel) + "\n    ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }